import { RootState } from '../../../config';

export const selectSharePointSettings = (state: RootState) =>
  state.userData?.sharepoint?.settings;

export const selectSharePointSites = (state: RootState) =>
  state.userData?.sharepoint?.sites;

export const selectSharePointDrives = (state: RootState) =>
  state.userData?.sharepoint?.drives;

export const selectSelectedSharePointSite = (state: RootState) =>
  state.userData?.sharepoint?.selectedSite;

export const selectSelectedSharePointDrive = (state: RootState) =>
  state.userData?.sharepoint?.selectedDrive;

export const selectSharePointLoading = (state: RootState) =>
  state.userData?.sharepoint?.loading;

export const selectSharePointSaving = (state: RootState) =>
  state.userData?.sharepoint?.saving;

export const selectSharePointError = (state: RootState) =>
  state.userData?.sharepoint?.error;

export const selectSharePointFolderPath = (state: RootState) =>
  state.userData?.sharepoint?.folderPath;

export const selectSharePointGrantResult = (state: RootState) =>
  state.userData?.sharepoint?.grantResult;
